export default siteScopes => {
  if (siteScopes.length === 1) {
    return siteScopes[0];
  }

  return (
    siteScopes.find(siteScope => {
      return siteScope.isDefault;
    }) ?? siteScopes[0]
  );
};
